export default "__VITE_ASSET__CDcFPJKX__"